import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import {
  Camera,
  CameraCapability,
  CameraConfiguration,
  CameraConnectionType,
  CameraState,
} from 'types/camera';
import { RtspConfig } from 'types/rtsp_config';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateCameraParams = {
  status?: CameraState;
  name?: string | null;
  model?: string | null;
  conn_type: CameraConnectionType;
  gateway_id?: string | null;
  uri?: string | null;
  ip_local?: string | null;
  ip_ext?: string | null;
  mac_address?: string | null;
  username?: string | null;
  password?: string | null;
  configuration?: CameraConfiguration | null;
  capabilities?: CameraCapability[] | null;
  external_id?: string | null;
  rtsp_config?: RtspConfig | null;
};

export function useCreateCamera({
  onSettled,
  onMutate,
  ...options
}: UseMutationOptions<Camera, APIError, UseCreateCameraParams> = {}) {
  const queryClient = useQueryClient();
  const { applicationID, client } = useAPI();

  return useMutation(
    async (params) => {
      const { data } = await client.post(
        `/apps/${applicationID}/cameras`,
        params
      );

      return data;
    },
    {
      ...options,
      onSettled: (...args) => {
        onSettled?.(...args);

        queryClient.invalidateQueries(['cameras']);
        queryClient.invalidateQueries(['camera']);
        queryClient.invalidateQueries(['video-sources']);
      },
    }
  );
}
